/**
 *
 * @param {String} parents
 */
export const makeURL = parents => {
    let url = "/";
    Object.keys(parents).forEach(key => {
        if (key !== "submodules") {
            if (parents[key]) {
                const regex = /(Id)+/g;
                let removeId = key.replace(regex, "/");
                let text = `${parents[key]}/`;
                url = url + removeId + text;
            }
        }
    });
    return url;
};
